/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AgentJobTypeEnum } from './agentJobTypeEnum';
import { AgentJobStatusEnum } from './agentJobStatusEnum';


export interface AgentJobsResponseSpec { 
    /**
     * Creation Timestamp.
     */
    creation_ts: Date;
    /**
     * Agent Job ID
     */
    id: string;
    /**
     * Agent Job Payload
     */
    payload?: object;
    status: AgentJobStatusEnum;
    type: AgentJobTypeEnum;
}
export namespace AgentJobsResponseSpec {
}


